import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store';
import { Toaster } from "react-hot-toast";
import AppLoader from './_common/pageLoader/appLoader';
import Dialog from './components/dialog';

// Mobile/Tablet detection function
const isMobileOrTablet = () => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  
  // Check for mobile devices
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
  
  // Check for tablet devices
  const tabletRegex = /ipad|android(?!.*mobi)|tablet/i;
  
  // Additional check for touch devices with smaller screens
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const isSmallScreen = window.innerWidth <= 1024; // Consider screens <= 1024px as mobile/tablet
  
  return mobileRegex.test(userAgent) || tabletRegex.test(userAgent) || (isTouchDevice && isSmallScreen);
};
console.log("mobile redirect to: " + process.env.REACT_APP_MOBILE_URL);

// Redirect to mobile URL if mobile/tablet device is detected
if (isMobileOrTablet() && process.env.REACT_APP_MOBILE_URL) {
  
  window.location.href = process.env.REACT_APP_MOBILE_URL;
} else {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <Provider store={store}>
       
      <Toaster position="top-center" reverseOrder={false} />
      <AppLoader />
      <Dialog />
      {/* <React.Fragment>
        <title>Riddell Gear</title>
        <link rel="icon" href="%PUBLIC_URL%/f_riddell_32.png" />
      </React.Fragment> */}
      <App />
      <span className='hidden w-0 h-0 overflow-hidden'>
        <span className='bg-primary hover:bg-primary-dark'></span>
        <span className='bg-secondary hover:bg-[#666666]'></span>
      </span>
    </Provider>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
